const iconButton = {
    basic: {
        icon: 'INK_600',
        iconHover: 'PRIMARY_600',
        iconActive: 'PRIMARY_700',
        bgHover: 'PRIMARY_100',
        bgActive: 'PRIMARY_200',
    },
    primary: {
        icon: 'INK_600',
        iconHover: 'PRIMARY_600',
        iconActive: 'PRIMARY_700',
        bgHover: 'PRIMARY_200',
        bgActive: 'PRIMARY_300',
    },
    disabled: {
        icon: 'INK_400',
        iconHover: 'INK_400',
        iconActive: 'INK_400',
        bgHover: 'TRANSPARENT',
        bgActive: 'TRANSPARENT',
    },
};
export default iconButton;
//# sourceMappingURL=iconButton.js.map